import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import ViewContainer from '@loggi/ui/components/view-container';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import {
  DELIVERY_UNTIL_MESSAGE,
  DELIVERY_UNTIL_TODAY_MESSAGE,
  RECEIVED_BY_MESSAGE,
  DELIVERED_AT_MESSAGE,
  DELIVERED_IN_MESSAGE,
  YESTERDAY_AT_MESSAGE,
  TODAY_AT_MESSAGE,
  TODAY_TEXT,
  TOMORROW_TEXT,
  AT_TEXT
} from './status-eta-message-constants';

const DeliveredYesterday = ({ dateTime, receivedBy }) => {
  return (
    <View>
      <ViewContainer>
        <Text size="300" weight="bold">
          {`${DELIVERED_AT_MESSAGE} `}
          <Text weight="bolder">{`${YESTERDAY_AT_MESSAGE} ${dateTime}`}</Text>.
        </Text>
      </ViewContainer>
      {receivedBy && (
        <ViewContainer>
          <Text size="300" weight="bold">
            {RECEIVED_BY_MESSAGE} <Text weight="bolder">{receivedBy}</Text>.
          </Text>
        </ViewContainer>
      )}
    </View>
  );
};

DeliveredYesterday.propTypes = {
  dateTime: PropTypes.string.isRequired,
  receivedBy: PropTypes.string.isRequired
};

const DeliveryUntilToday = () => {
  return (
    <Fragment>
      <Icon type={icons.type.CLOCK_OUTLINE} />
      <Text size="300" weight="bold">
        {DELIVERY_UNTIL_TODAY_MESSAGE}
        <Text weight="bolder">{TODAY_TEXT}</Text>.
      </Text>
    </Fragment>
  );
};

const DeliveredToday = ({ dateTime, receivedBy }) => {
  return (
    <View>
      <ViewContainer>
        <Text size="300" weight="bold">
          {`${DELIVERED_AT_MESSAGE} `}
          <Text weight="bolder">{`${TODAY_AT_MESSAGE} ${dateTime}`}</Text>.
        </Text>
      </ViewContainer>
      {receivedBy && (
        <ViewContainer>
          <Text size="300" weight="bold">
            {RECEIVED_BY_MESSAGE} <Text weight="bolder">{receivedBy}</Text>.
          </Text>
        </ViewContainer>
      )}
    </View>
  );
};

DeliveredToday.propTypes = {
  dateTime: PropTypes.string.isRequired,
  receivedBy: PropTypes.string.isRequired
};

const DeliveryUntilTomorrow = () => {
  return (
    <Fragment>
      <Icon type={icons.type.CLOCK_OUTLINE} />
      <Text size="300" weight="bold">
        {DELIVERY_UNTIL_MESSAGE}
        <Text weight="bolder">{TOMORROW_TEXT}</Text>.
      </Text>
    </Fragment>
  );
};

const DeliveredMuchTimeAgo = ({ date, dateTime, receivedBy }) => {
  return (
    <View>
      <ViewContainer>
        <Text size="300" weight="bold">
          {`${DELIVERED_IN_MESSAGE} `}
          <Text weight="bolder">{`${date} ${AT_TEXT} ${dateTime}`}</Text>.
        </Text>
      </ViewContainer>
      {receivedBy && (
        <ViewContainer>
          <Text size="300" weight="bold">
            {RECEIVED_BY_MESSAGE} <Text weight="bolder">{receivedBy}</Text>.
          </Text>
        </ViewContainer>
      )}
    </View>
  );
};

DeliveredMuchTimeAgo.propTypes = {
  date: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  receivedBy: PropTypes.string.isRequired
};

const DeliverySoon = ({ date }) => {
  return (
    <Fragment>
      <Icon type={icons.type.CLOCK_OUTLINE} />
      <Text size="300" weight="bold">
        {DELIVERY_UNTIL_MESSAGE}
        <Text weight="bolder">{date}</Text>.
      </Text>
    </Fragment>
  );
};

DeliverySoon.propTypes = {
  date: PropTypes.string.isRequired
};

export {
  DeliveredYesterday,
  DeliveryUntilToday,
  DeliveredToday,
  DeliveryUntilTomorrow,
  DeliveredMuchTimeAgo,
  DeliverySoon
};
